<template>
  <section class="invoice-add-wrapper">
    <b-row class="invoice-add">
      <!-- CARD ESQUERDA -->
      <b-col cols="12" xl="9" md="8">
        <b-alert :variant="getErrors.color" v-if="getErrors.hasMessage" show="">
          <div class="alert-body my-2" v-for="(error, index) in getErrors.messageArray" :key="index">
            {{ error[0] }}
          </div>
          <div class="alert-body">{{ getErrors.message }}</div>
        </b-alert>
        
        <validation-observer ref="formPedidos">
          <b-form @submit.prevent>
            <b-card no-body class="invoice-preview-card">
              <h5 class="text-center mt-2">{{ $t('Pedido_para') }}: <span class="text-primary">{{ nomeLaboSelecionado }} </span></h5>
              
              <!-- DETALHES DO PEDIDO-->
              <b-card-body class="invoice-padding pt-0" style="padding-bottom: 0">
                <b-row class="invoice-spacing">
                  
                  <!-- CRO -->
                  <b-col v-if="getPais === 'US'" >
                    <label class="d-inline">DDS or DMD (required) </label>
                    <validation-provider
                      #default="{ errors }"
                      name="DDS or DMD"
                      :rules="getPais === 'US' ? 'max:50|required' : '' "
                    >
                    
                    <b-form-input id="paciente" v-model="form.cro"/>
                    <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-col>
                  
                  <!-- DENTISTA CONVENIADO -->
                  <b-col>
                    <label class="d-inline">{{ $t('Dentista_Conveniado_Opcional') }}</label>
                    <v-select
                      v-model="form.conveniado_id"
                      label="conveniado_nome"
                      :reduce="conveniado => conveniado.id"
                      :options="filteredConveniados"
                      :clearable="podeLimparSelectConveniados"
                    >
                      <div slot="no-options">
                        {{ $t('Dentista_Conveniado_Nao_Encontrado') }}
                      </div>
                    </v-select>
                  </b-col>
                  
                  <!-- PACIENTE -->
                  <b-col cols="12" sm="6" md="7" lg="7">
                    <label class="d-inline">{{ $t('Paciente_Obrigatorio') }}</label>
                    <validation-provider
                      #default="{ errors }"
                      :name="$t('Paciente')"
                      rules="max:50|required"
                    >
                      <b-input-group>
                        <b-input-group-prepend is-text>
                          <feather-icon icon="UserIcon"></feather-icon>
                        </b-input-group-prepend>
                        <b-form-input id="paciente" v-model="form.paciente"/>
                      </b-input-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-col>
                
                </b-row>
                <b-row class="invoice-spacing">
                  
                  <!-- MATERIAIS -->
                  <b-col cols="12">
                    <!--                    <Materiais @materiais="form.materiais = $event"/>-->
                    <ModalMateriaisDropdown
                      ref="materiaisDropdown"
                      @materiais="form.materiais = $event"
                      :componentesEditar="[]"
                    />
                  </b-col>
                </b-row>
              
              </b-card-body>
              
              <!-- SERVIÇOS ITEMS -->
              
              <b-card-body
                style="background-color: #f5f5f5; padding: 10px;"
                v-for="(servico, index) in form.servicos"
                :key="index"
              >
                <b-card class="mb-0">
                  <template #header>
                    <div class="d-flex justify-content-between align-items-center w-100 flex-wrap">
                      <div class="d-flex align-items-center flex-wrap mr-1 my-25">
                        <h4 class="text-primary mb-0 mr-1">
                          {{ servico.nome ? servico.nome : $t('Nenhum_Servico_Selecionado') }}
                        </h4>
                        <b-badge
                          v-if="servico.id"
                          :variant="getTipoCobrancaInfo(servico.tipo_cobranca).variant"
                          class="font-weight-bolder py-50 px-75 d-inline-flex align-items-center"
                        >
                          <feather-icon :icon="getTipoCobrancaInfo(servico.tipo_cobranca).icon" size="12" class="mr-25" />
                          {{ getTipoCobrancaInfo(servico.tipo_cobranca).label }}
                        </b-badge>
                      </div>
                      
                      <div class="d-flex align-items-center my-25 ml-auto">
                        <strong class="text-primary mr-1 align-items-center">
                          {{ $t('Subtotal') }}: {{ servico.subTotal + servico.subTotalProdutos | formataMoeda }}
                        </strong>
                        <b-button
                          size="sm"
                          v-b-toggle="'collapse-' + index"
                          variant="outline-primary"
                          class="btn-icon mx-25"
                        >
                          <feather-icon icon="ChevronDownIcon" />
                        </b-button>
                        <b-button
                          v-if="index > 0"
                          size="sm"
                          variant="outline-danger"
                          class="btn-icon ml-25"
                          @click="removeItem(index)"
                        >
                          <feather-icon
                            icon="XIcon"
                            class="cursor-pointer text-danger"
                          />
                        </b-button>
                      </div>
                    </div>
                  </template>
                  
                  <b-collapse
                    type="margin"
                    visible
                    :id="`collapse-${index}`"
                  >
                    <div
                      ref="form"
                      class="repeater-form"
                      :style="{ height: trHeight }">
                      
                      <b-row ref="row">
                        <b-col cols="12">
                          <div class="d-none d-lg-flex">
                            <b-row class="flex-grow-1 px-1">
                              <b-col cols="12" lg="5"> {{ $t('Servico') }} </b-col>
                              <b-col cols="12" lg="2"> {{ $t('Quantidade') }} </b-col>
                              <b-col cols="12" lg="3">
                                {{ $t('Valor_Unitario') }}
                                <span
                                  v-if="Number(servico.iva > 0)"
                                  class="text-primary"
                                >
                                    + %{{ servico.iva}} {{ $t('Imposto') }}
                                </span>
                              </b-col>
                              <b-col cols="12" lg="2"> {{ $t('Desconto') }} </b-col>
                            </b-row>
                            <div class="form-item-action-col" />
                          </div>
                          
                          <div class="border rounded">
                            <b-row class="flex-grow-1 p-1">
                            
                              <!-- SERVIÇO-->
                              <b-col cols="12" lg="5">
                                <label class="d-inline d-lg-none">{{ $t('Servico') }}</label>
                                <validation-provider
                                  #default="{ errors }"
                                  :name="$t('Servico')"
                                  rules="required"
                                >
                                  <v-select
                                    label="nome"
                                    v-model="servico.nome"
                                    :clearable="false"
                                    :options="categorias.servicos"
                                    class="mb-1 item-selector-title"
                                    :placeholder="$t('Selecione_Um_Servico')"
                                    :selectable="(option) => option.posicao > 0"
                                    @input="val => mudouServico(index, val)"
                                  >
                                    <template #option="{ nome, posicao }">
                                      <h5
                                        v-if="posicao === 0"
                                        class="text-primary"
                                        style="margin: 0"
                                      >
                                        {{ nome }}
                                      </h5>
                                      <em v-else class="pl-2">
                                        {{ nome }}
                                      </em>
                                    
                                    </template>
                                  </v-select>
                                  <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>

                                <div v-if="servico.id" class="d-flex align-items-center mb-1">
                                  <span class="font-small-2 text-muted mr-50">{{ $t('Tipo_Cobranca') }}:</span>
                                  <b-badge
                                    :variant="getTipoCobrancaInfo(servico.tipo_cobranca).variant"
                                    class="font-small-1 font-weight-bold d-inline-flex align-items-center"
                                  >
                                    <feather-icon :icon="getTipoCobrancaInfo(servico.tipo_cobranca).icon" size="10" class="mr-25" />
                                    {{ getTipoCobrancaInfo(servico.tipo_cobranca).label }}
                                  </b-badge>
                                </div>
                              </b-col>
                              
                              <!-- QUANTIDADE-->
                              <b-col cols="12" lg="2">
                                <label class="d-inline d-lg-none">{{ $t('Quantidade') }}</label>
                                <validation-provider
                                  #default="{ errors }"
                                  :name="$t('Quantidade')"
                                  rules="maior_zero|required"
                                >
                                  <small class="text-danger">{{ errors[0] }}</small>
                                  <b-form-spinbutton
                                    v-model="servico.quantidade"
                                    :disabled="isQuantidadeDisabled(servico)"
                                    min="1"
                                    @change="alterouQuantidade(index, servico.quantidade)"
                                  />
                                </validation-provider>
                              </b-col>
                              
                              <!-- VALOR UNITÁRIO-->
                              <b-col cols="12" lg="3">
                                <label class="d-inline d-lg-none">
                                  {{ $t('Valor_Unitario') }}
                                </label>
                                <money
                                  v-bind="money"
                                  :disabled="true"
                                  :value="servico.valor"
                                  :state="errors.length > 0 ? false : null"
                                  class="form-control mb-2"
                                  type="text"
                                />
                              </b-col>
                              
                              <!-- DESCONTO-->
                              <b-col cols="12" lg="2">
                                <label class="d-inline d-lg-none">{{ $t('Desconto') }} %</label>
                                <b-form-input
                                  :disabled="true"
                                  type="number"
                                  class="mb-2"
                                  v-model="servico.desconto"
                                />
                              </b-col>
                              
                              <!-- Imposto-->
<!--                              <b-col cols="12" lg="2" v-if="servico.iva > 0">
                                <label class="d-inline">{{ $t('Imposto') }} %</label>
                                <b-form-input
                                  :disabled="true"
                                  type="number"
                                  class="mb-2"
                                  v-model="servico.iva"
                                />
                              </b-col>-->
                              
                              <!-- ODONTOGRAMA-->
                              <b-col cols="12" lg="7">
                                <label class="d-inline d-lg-none">{{ $t('Dentes') }}</label>
                                <div class="demo-inline-spacing text-center mt-0">
                                  <b-form-radio
                                    v-model="servico.odontograma"
                                    class="custom-control-primary"
                                    :name="`permanente-${index}`"
                                    :id="`permanente-${index}`"
                                    value="odontograma"
                                    @change="$refs.odontogramaComponente[index].desativaTodos()"
                                  >
                                    {{ $t('Permanente') }}
                                  </b-form-radio>
                                  
                                  <b-form-radio
                                    v-model="servico.odontograma"
                                    class="custom-control-primary"
                                    :name="`deciduos-${index}`"
                                    :id="`deciduos-${index}`"
                                    value="odontograma-crianca"
                                    @change=" $refs.odontogramaComponente[index].desativaTodos()"
                                  >
                                    {{ $t('Deciduos') }}
                                  </b-form-radio>
                                </div>
                                <keep-alive>
                                  <validation-provider
                                    #default="{ errors }"
                                    :name="$t('Numero_Dente')"
                                    rules="required"
                                  >
                                    <component
                                      :is="servico.odontograma"
                                      ref="odontogramaComponente"
                                      :dentes-selecionados="form.servicos[index].num_dente"
                                      :indexComponente="index"
                                      :servico-selecionado="!!servico.id"
                                      :tipo-cobranca="servico.tipo_cobranca"
                                      v-model="form.servicos[index].dente"
                                      @denteSelecionado="onDenteSelecionado(index, $event)"
                                    />
                                    <small
                                      v-if="errors[0]"
                                      class="text-danger d-block text-center mt-50"
                                    >
                                      {{ errors[0] }}
                                    </small>
                                  </validation-provider>
                                </keep-alive>
                              
                              </b-col>
                              
                              <!-- COR-->
                              <b-col>
                                <label class="d-inline"> <span class="font-weight-bold">{{ $t('Escala_Cor') }}:
                                  </span></label>
                                <validation-provider
                                  #default="{ errors }"
                                  name="Cor do Dente"
                                  rules="max:80"
                                >
                                  <b-form-textarea
                                    v-model="servico.cor_dente"
                                    :state="errors.length > 0 ? false : null"
                                    class="mb-2" type="text"
                                  />
                                  
                                  <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                                
                                <label
                                  class="d-inline">
                                    <span class="font-weight-bold">
                                      {{ $t('Observacao') }}:
                                    </span>
                                </label>
                                <validation-provider
                                  #default="{ errors }"
                                  name="Observações"
                                  rules="max:500"
                                >
                                  <b-form-textarea
                                    v-model="servico.observacao_item"
                                    :state="errors.length > 0 ? false : null"
                                    class="mb-2"
                                    rows="7"
                                    type="text"
                                  />
                                  
                                  <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                              
                              </b-col>

                              <!-- FORMULÁRIO DINÂMICO -->
                              <b-col
                                v-if="servico.formulario_config && servico.formulario_config.length"
                                cols="12"
                                class="mt-2"
                              >
                                <h5 class="text-primary mb-1">
                                  {{ $t('Informacoes_Adicionais') }}
                                </h5>
                                <b-row>
                                  <b-col
                                    v-for="(campo, campoIndex) in servico.formulario_config"
                                    :key="campoIndex"
                                    cols="12"
                                    v-if="deveMostrarCampo(servico, campo)"
                                  >
                                    <b-row>

                                      <!-- OPÇÕES DO CAMPO -->
                                      <b-col
                                        cols="12"
                                        :lg="temImagemOpcoes(campo) ? 7 : 12"
                                      >
                                        <b-form-group :label="campo.label">
                                          <validation-provider
                                            #default="{ errors }"
                                            :name="campo.label"
                                            :rules="(campo.required ? 'required' : '') + (campo.max_length ? '|max:' + campo.max_length : '')"
                                          >
                                            <b-form-radio-group
                                              v-if="campo.tipo === 'radio'"
                                              v-model="servico.formulario_dados[campo.name]"
                                              stacked
                                              :state="errors.length > 0 ? false : null"
                                              @input="alterouQuantidade(index, servico.quantidade), atualizarPreviewImagem(index, campo)"
                                            >
                                              <b-form-radio
                                                v-for="(option, optIndex) in campo.options"
                                                :key="optIndex"
                                                :value="option.value || option.label"
                                                class="mb-50"
                                              >
                                                <span class="d-inline-flex align-items-center">
                                                  <b-img
                                                    v-if="option.imagem && option.imagem.url"
                                                    :src="getImagemUrl(option.imagem)"
                                                    class="opcao-thumb d-lg-none mr-1"
                                                    rounded
                                                    @click.stop.prevent="abrirImagemMobile(getImagemUrl(option.imagem))"
                                                  />
                                                  {{ option.label }}
                                                  <span
                                                    v-if="option.adicional > 0"
                                                    class="text-success ml-25"
                                                  >
                                                    (+ {{ option.adicional | formataMoeda }})
                                                  </span>
                                                </span>
                                              </b-form-radio>
                                            </b-form-radio-group>

                                            <b-form-select
                                              v-else-if="campo.tipo === 'select'"
                                              v-model="servico.formulario_dados[campo.name]"
                                              :options="renderOptions(campo.options)"
                                              :state="errors.length > 0 ? false : null"
                                              @input="alterouQuantidade(index, servico.quantidade), atualizarPreviewImagem(index, campo)"
                                            />

                                            <b-form-checkbox-group
                                              v-else-if="campo.tipo === 'checkbox'"
                                              :checked="servico.formulario_dados[campo.name]"
                                              stacked
                                              :state="errors.length > 0 ? false : null"
                                              @input="val => alterouCheckbox(val, index, campo)"
                                            >
                                              <b-form-checkbox
                                                v-for="(option, optIndex) in campo.options"
                                                :key="optIndex"
                                                :value="option.value || option.label"
                                                class="mb-50"
                                              >
                                                <span class="d-inline-flex align-items-center">
                                                  <b-img
                                                    v-if="option.imagem && option.imagem.url"
                                                    :src="getImagemUrl(option.imagem)"
                                                    class="opcao-thumb d-lg-none mr-1"
                                                    rounded
                                                    @click.stop.prevent="abrirImagemMobile(getImagemUrl(option.imagem))"
                                                  />
                                                  {{ option.label }}
                                                  <span
                                                    v-if="option.adicional > 0"
                                                    class="text-success ml-25"
                                                  >
                                                    (+ {{ option.adicional | formataMoeda }})
                                                  </span>
                                                </span>
                                              </b-form-checkbox>
                                            </b-form-checkbox-group>

                                            <b-form-input
                                              v-else-if="campo.tipo === 'text' && (!campo.max_length || campo.max_length <= 100)"
                                              v-model="servico.formulario_dados[campo.name]"
                                              :state="errors.length > 0 ? false : null"
                                              @input="alterouQuantidade(index, servico.quantidade)"
                                            />
                                            <b-form-textarea
                                              v-else-if="campo.tipo === 'text'"
                                              v-model="servico.formulario_dados[campo.name]"
                                              :state="errors.length > 0 ? false : null"
                                              rows="3"
                                              @input="alterouQuantidade(index, servico.quantidade)"
                                            />
                                            <small class="text-danger">{{ errors[0] }}</small>
                                          </validation-provider>
                                        </b-form-group>
                                      </b-col>

                                      <!-- PREVIEW DA IMAGEM (SOMENTE DESKTOP) -->
                                      <b-col
                                        v-if="temImagemOpcoes(campo) && previewImagem[`${index}-${campo.name}`] && previewImagem[`${index}-${campo.name}`].length"
                                        cols="12"
                                        lg="5"
                                        class="d-none d-lg-block"
                                      >
                                        <div class="imagem-preview-container">
                                          <b-img
                                            v-for="(img, imgIndex) in previewImagem[`${index}-${campo.name}`]"
                                            :key="imgIndex"
                                            :src="img"
                                            fluid
                                            thumbnail
                                            class="mb-1 imagem-preview-img"
                                          />
                                        </div>
                                      </b-col>

                                    </b-row>
                                  </b-col>
                                </b-row>
                              </b-col>
                              
                              <!-- ADD PRODUTOS (OCULTO) -->
                              <!--
                              <b-col cols="12">
                                <b-button
                                  class="mr-1 mb-1"
                                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                  size="sm"
                                  variant="success"
                                  @click="addNewProductInItemForm(index)"
                                >
                                  <feather-icon icon="PlusIcon"></feather-icon> {{ $t('Produto') }}
                                </b-button>
                              </b-col>
                              -->
                              
                              <b-col cols="12" v-for="(produto, indexProd) in servico.produtos" :key="indexProd">
                                <div class="d-flex">
                                  <b-row class="flex-grow-1">
                                    
                                    <!-- PRODUTOS -->
                                    <b-col cols="8" lg="5" md="6">
                                      <b-form-group
                                        :label="$t('Selecione_Um_Produto')"
                                        label-for="produto"
                                      >
                                        <validation-provider
                                          #default="{ errors }"
                                          mode="eager"
                                          name="Produto"
                                          rules="required"
                                        >
                                          <v-select
                                            id="produto"
                                            v-model="produto.nome"
                                            :clearable="false"
                                            :options="categorias.produtos"
                                            label="nome"
                                            @input="prod => mudouProduto(index, indexProd, prod)"
                                          >
                                            <template #no-options>
                                              {{ $t('Produto_Nao_Encontrado') }}
                                            </template>
                                          </v-select>
                                          <small class="text-danger">{{ errors[0] }}</small>
                                        </validation-provider>
                                      </b-form-group>
                                    </b-col>
                                    
                                    <!-- PRODUTOS QUANTIDADE -->
                                    <b-col cols="12" lg="2">
                                      <b-form-group
                                        :label="$t('Quantidade')"
                                        label-for="produto_quantidade"
                                      >
                                        <validation-provider
                                          #default="{ errors }"
                                          :name="$t('Quantidade')"
                                          rules="maior_zero|required"
                                        >
                                          <small class="text-danger">
                                            {{ errors[0] }}
                                          </small>
                                          <b-form-spinbutton
                                            v-model="produto.quantidade"
                                            min="1"
                                            @change="alterouQuantidadeProduto(index, indexProd, produto.quantidade)"
                                          />
                                        </validation-provider>
                                      </b-form-group>
                                    </b-col>
                                    
                                    <!-- PRODUTOS VALOR -->
                                    <b-col>
                                      <label class="d-inline">{{ $t('Valor') }}
                                        <span
                                          v-if="Number(produto.iva > 0)"
                                          class="text-primary"
                                        >
                                          + %{{ produto.iva}} {{ $t('Imposto') }}
                                        </span>
                                      </label>
                                      
                                      <validation-provider
                                        #default="{ errors }"
                                        name="Valor"
                                        rules="positive"
                                      >
                                        <money
                                          v-bind="money"
                                          :disabled="true"
                                          :value="produto.valor"
                                          :state="errors.length > 0 ? false : null"
                                          class="form-control mb-2"
                                          type="text"
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                      </validation-provider>
                                    </b-col>
                                    
                                    <!-- PRODUTOS SUBTOTAL -->
                                    <b-col>
                                      <label class="d-inline">{{ $t('Subtotal') }}</label>
                                      <validation-provider
                                        #default="{ errors }"
                                        name="Valor"
                                        rules="positive"
                                      >
                                        <money
                                          v-bind="money"
                                          :disabled="true"
                                          :value="produto.subTotal"
                                          :state="errors.length > 0 ? false : null"
                                          class="form-control mb-2"
                                          type="text"
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                      </validation-provider>
                                    </b-col>
                                    <b-col cols="12" lg="1" class="mt-2">
                                      <b-button
                                        class="btn-icon"
                                        variant="outline-danger"
                                        @click="excluirProduto(index, indexProd)"
                                      >
                                        <feather-icon icon="XCircleIcon"></feather-icon>
                                      </b-button>
                                    </b-col>
                                  </b-row>
                                </div>
                              </b-col>
                            
                            </b-row>
                            
                            <!-- REMOVE SERVIÇO-->
                            <div v-if="index > 0"
                                 class="d-flex flex-column justify-content-between border-left py-50 px-25">
                              <feather-icon
                                size="16"
                                icon="XIcon"
                                class="cursor-pointer text-danger"
                                @click="removeItem(index)"
                              />
                            </div>
                          </div>
                        
                        </b-col>
                      </b-row>
                      
                      <b-row>
                        <b-col v-if="servico.data_prazo">
                          <strong class="text-primary">
                            {{ $t('Prazo_Entrega') }}: {{ servico.data_prazo | convertData }}
                          </strong>
                          <em class="text-muted">
                            {{ $t('Obs_Prazo_Variavel') }}
                          </em>
                        </b-col>
                      </b-row>
                    
                    </div>
                  
                  </b-collapse>
                </b-card>
              </b-card-body>
              
              
              <!-- BOTÕES -> SERVIÇOS E GRAVAR PEDIDO -->
              <b-row class="m-1">
                <b-col cols="12" md="6" class="p-50">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    size="sm"
                    variant="outline-primary"
                    block
                    @click="addNewItemInItemForm()"
                  >
                    <feather-icon icon="PlusIcon"></feather-icon> {{ $t('Adicionar_Outro_Servico_No_Pedido') }}
                  </b-button>
                </b-col>
                <b-col cols="12" md="6" class="p-50">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    size="sm"
                    variant="primary"
                    block
                    :disabled="submit || (deveMostrarTermos && !permitirConcordar) || precisaAssinatura"
                    @click="gravaPedido"
                  >
                    {{ $t('Enviar_Pedido') }}
                  </b-button>
                </b-col>
              </b-row>
              
              <!-- Invoice Description: Total -->
              <b-card-body class="invoice-padding pb-0">
              </b-card-body>
              
              <!-- Note / Anexar Arquivos e Imagens -->
              <b-card-body class="invoice-padding pt-2" body-border-variant="primary">
                <div class="d-flex justify-content-between align-items-center mb-1">
                  <div class="d-flex align-items-center flex-wrap">
                    <span class="font-weight-bold h5 mb-0 mr-1">{{ $t('Anexar_Arquivos_Imagens') }}</span>
                    <b-badge v-if="files.length" variant="light-primary" pill class="font-weight-bold py-50 px-1">
                      {{ files.length }} {{ files.length === 1 ? ($t('arquivo') || 'arquivo') : ($t('arquivos') || 'arquivos') }} • {{ totalArquivosSize }}
                    </b-badge>
                  </div>
                  <b-button v-if="files.length" variant="outline-danger" size="sm" class="btn-clean-files" @click="limparArquivos">
                    <feather-icon icon="Trash2Icon" size="14" class="mr-25" />{{ $t('Limpar') }}
                  </b-button>
                </div>

                <b-alert v-if="statusUpload === false" variant="danger" show class="mb-1">
                  <div class="alert-body">
                    <feather-icon icon="AlertCircleIcon" class="mr-50" />
                    <span>{{ $t('Maximo_Arquivos') }}</span>
                  </div>
                </b-alert>

                <!-- Input real invisível -->
                <input
                  ref="hiddenFileInput"
                  type="file"
                  multiple
                  accept="image/*, .pdf, .mov, .mp4, .avi, .flv, .mkv, Webm, .stl, .dicom, .dcm, .zip, .ply, .rar, .obj"
                  class="d-none"
                  @change="filesUpload"
                />

                <!-- Área Dropzone Interativa -->
                <div
                  class="custom-dropzone"
                  :class="{ 'is-dragover': isDragging }"
                  @click="triggerFileInput"
                  @dragover.prevent="onDragOver"
                  @dragenter.prevent="onDragOver"
                  @dragleave.prevent="onDragLeave"
                  @drop.prevent="onDropFiles"
                >
                  <div class="dropzone-content text-center py-2 px-1">
                    <div class="dropzone-icon-wrapper mb-1">
                      <feather-icon icon="UploadCloudIcon" size="36" class="text-primary" />
                    </div>
                    <h5 class="dropzone-title font-weight-bolder mb-50">
                      {{ $t('Arraste_e_solte_arquivos_aqui_ou') }}
                    </h5>
                    <p class="dropzone-subtitle text-muted mb-1 font-small-3">
                      {{ $t('Formatos_suportados_odontodocs') }}
                    </p>
                    <div class="dropzone-badges d-flex flex-wrap justify-content-center">
                      <b-badge variant="light-primary" class="mr-50 mb-50">3D (STL / PLY / OBJ)</b-badge>
                      <b-badge variant="light-info" class="mr-50 mb-50">DICOM / DCM</b-badge>
                      <b-badge variant="light-success" class="mr-50 mb-50">Imagens (JPG, PNG)</b-badge>
                      <b-badge variant="light-danger" class="mr-50 mb-50">Documentos (PDF)</b-badge>
                      <b-badge variant="light-warning" class="mr-50 mb-50">ZIP / RAR</b-badge>
                    </div>
                  </div>
                </div>

                <!-- Preview dos arquivos selecionados -->
                <div v-if="files.length" class="mt-2">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <span class="text-muted font-small-3 font-weight-bold text-uppercase">
                      {{ $t('Arquivos_Selecionados') }} ({{ files.length }})
                    </span>
                  </div>

                  <b-row class="match-height file-previews-grid">
                    <b-col
                      v-for="(file, index) in files"
                      :key="index"
                      cols="12"
                      sm="6"
                      md="4"
                      lg="3"
                      class="mb-1"
                    >
                      <div class="file-card-modern">
                        <div class="file-card-thumb">
                          <!-- Imagem -->
                          <img
                            v-if="file.type && file.type.startsWith('image/')"
                            :src="filePreviewUrls[index]"
                            class="file-card-img"
                            :alt="file.name"
                          />
                          <!-- Ícone de Documento / STL / DICOM / etc -->
                          <div v-else class="file-card-icon-container" :class="'bg-' + getFileTypeCategory(file)">
                            <feather-icon
                              :icon="getFileIcon(file)"
                              size="32"
                              :class="'text-' + getFileTypeCategory(file)"
                            />
                          </div>

                          <!-- Badge de Tipo de Arquivo -->
                          <b-badge
                            :variant="getFileBadgeVariant(file)"
                            class="file-type-badge font-weight-bolder"
                          >
                            {{ getFileExtension(file) }}
                          </b-badge>

                          <!-- Botão de Deletar -->
                          <button
                            type="button"
                            class="btn-delete-file"
                            :title="$t('Remover')"
                            @click.stop="removerArquivo(index)"
                          >
                            <feather-icon icon="XIcon" size="14" />
                          </button>
                        </div>

                        <div class="file-card-details">
                          <span class="file-card-name text-truncate" :title="file.name">
                            {{ file.name }}
                          </span>
                          <span class="file-card-size text-muted font-small-2">
                            {{ formatFileSize(file.size) }}
                          </span>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </b-card-body>
            </b-card>
          </b-form>
        </validation-observer>
      </b-col>
      
      <!-- CARD DIREITA-->
      
      <b-col
        cols="12"
        md="4"
        xl="3"
        class="invoice-actions mt-md-0 mt-2"
        v-if="!mostraDetalhesPedido"
      >
        
        <!-- Buttons -->
        <b-card>
          
          <!-- AUTORIZAR USUÁRIO -->
          <!--          <b-row class="mb-1">
                      <b-col>
                        <label for="usuario" class="text-nowrap mr-50">Permitir Acesso (Usuário):</label>
                        <v-select
                            label="name"
                            :multiple="true"
                            v-model="form.user_id"
                            :options="usuarios"
                            class="mb-2 item-selector-title"
                            :reduce="user => user.id"
                            :selectable="(option) => option.tipo_usuario > 1"
                        >
                        </v-select>
                      </b-col>
                    </b-row>-->
          
          <!-- TAXA ENTREGA -->
          <div class="d-flex justify-content-between align-items-center">
            <label for="patymentTerms">{{ $t('Incluir_Taxa_Entrega') }}</label>
            <b-form-checkbox
              id="entrega"
              v-model="form.entrega"
              :checked="true"
              switch
            />
          </div>
          
          <!-- SOLICITAR RETIRADA -->
          <div class="d-flex justify-content-between align-items-center my-1 mb-2">
            <label for="clientNotes">{{ $t('Solicitar_Retirada') }}</label>
            <b-form-checkbox
              id="retirada"
              v-model="form.retirada"
              :checked="true"
              switch
            />
          </div>
          
          <hr>
          
          <!-- VALORES TOTAIS-->
          <b-row>
            <!--DESCRIÇÃO VALORES TOTAIS DE PEDIDO -->
            <b-col class="mt-md-12 d-flex justify-content-end">
              <div class="invoice-total-wrapper">
                
                <div class="invoice-total-item">
                  <p class="invoice-total-title">{{ $t('Servicos') }}:</p>
                  <p class="invoice-total-amount"> {{ valorTotalPedido.valorBruto | formataMoeda }} </p>
                </div>
                
                <div class="invoice-total-item">
                  <p class="invoice-total-title">{{ $t('Produtos') }}:</p>
                  <p class="invoice-total-amount"> {{ valorTotalProdutos.valorBruto | formataMoeda }} </p>
                </div>
                
                <div class="invoice-total-item">
                  <p class="invoice-total-title">{{ $t('Transporte') }}: </p>
                  <p class="invoice-total-amount"> {{ valorEntrega | formataMoeda }}</p>
                </div>
                
                <div class="invoice-total-item">
                  <p class="invoice-total-title">{{ $t('Desconto') }}: </p>
                  <p class="invoice-total-amount"> <span v-if="valorTotalPedido.totalDesconto"> - </span>
                    {{ valorTotalPedido.totalDesconto | formataMoeda }}
                  </p>
                </div>
                
                <div class="invoice-total-item" v-if="valorTotalPedido.totalIva + valorTotalProdutos.valorIva > 0">
                  <p class="invoice-total-title">{{ $t('Imposto') }}: </p>
                  <p class="invoice-total-amount"> <span > +  </span>
                    {{ valorTotalPedido.totalIva + valorTotalProdutos.valorIva | formataMoeda }}
                  </p>
                </div>
                
                <hr class="my-50">
                
                <div class="invoice-total-item">
                  <p class="invoice-total-title text-primary">{{ $t('Total') }}:</p>
                  <p class="invoice-total-amount text-primary">
                    {{ valorTotalPedido.valorLiquido + valorTotalProdutos.valorLiquido + valorEntrega  | formataMoeda }}
                  </p>
                </div>
                
              </div>
            </b-col>
          </b-row>
          
          <hr>
          
          <div v-if="deveMostrarTermos" class="d-flex align-items-center terms-container">
            <b-form-checkbox
              v-model="permitirConcordar"
              switch
              class="terms-checkbox"
            >
              {{ $t('Eu_concordo_com_os') }}
            </b-form-checkbox>
            <b class="text-primary cursor-pointer terms-link" @click="abreModalTermos">
              {{ $t('Termos_de_Servico') }}
            </b>
          </div>
          
          
          <!-- ASSINATURA -->
          <Assinatura
            v-if="precisaAssinatura"
            @signature-saved="setSignature"
            ref="assinatura"
          />
          
          
          <!-- Button: GRAVAR E ENVIAR PEDIDO -->
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mb-75"
            block
            :disabled="submit || (deveMostrarTermos && !permitirConcordar) || precisaAssinatura"
            @click="gravaPedido"
          >
            {{ $t('Enviar_Pedido') }}
          </b-button>
          
          
          <b-progress
            class="mt-2 progress-bar-success"
            variant="success"
            :value="porcentagem"
            max="100"
          />
          <span v-if="porcentagem !== 0">
            <strong
              class="text-success text-center">
            {{ porcentagem }} 
          </strong>
          </span>
        </b-card>
      
      </b-col>
      
      <ModalLancarPedido
        ref="modalLancarPedido"
        :files="files"
        :pedidoId="pedidoId"
        :public_token="public_token"
        :laboratorios="laboratorios"
        :uploadProgress="uploadProgress"
        @uploadCompleted="uploadCompleted()"
        @fechouModal="resetFiles"
      />
      
      <ModalTermosServico
        v-if="deveMostrarTermos"
        :nome-laboratorio="nomeLaboSelecionado"
        :termo="termoLaboratorio"
        :permitirConcordar="permitirConcordar"
        @termosAceitos="handleTermosAceitos"
      />

      <!-- MODAL IMAGEM OPÇÃO (MOBILE) -->
      <b-modal
        id="modalImagemOpcao"
        hide-footer
        centered
        size="md"
        :title="$t('Visualizar_Imagem')"
      >
        <b-img :src="modalImagemUrl" fluid center />
      </b-modal>
    
    </b-row>
  
  </section>
</template>

<style lang="scss" scoped>
.terms-container {
  .terms-checkbox {
    margin-right: -0.5rem;
    
    ::v-deep .custom-control-label {
      margin-right: 0;
    }
  }
  
  .terms-link {
    font-size: 10px;
    padding: 15px 10px 20px; // Reduz o padding à esquerda
  }
}
</style>

<script>

import {ValidationObserver, ValidationProvider} from "vee-validate";
import Logo from '@core/layouts/components/Logo.vue'
import {heightTransition} from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import {max} from '@core/utils/validations/validations'
import dataOpcoes from './dataOpcoes'
import Odontograma from "@/views/pedidos/odontograma/NewOdontograma.vue"
import OdontogramaCrianca from "@/views/pedidos/odontograma/NewOdontogramaCrianca.vue"
import ModalTermosServico from './ModalTermosServico.vue'
import Assinatura from './Assinatura.vue'

import {
  BAlert,
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BCardHeader,
  BCardText,
  BCol,
  BCollapse,
  BForm,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BFormRadioGroup,
  BFormSelect,
  BFormSpinbutton,
  BFormTextarea,
  BImg,
  BInputGroup,
  BInputGroupPrepend,
  BModal,
  BPopover,
  BProgress,
  BRow,
  VBToggle,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {mapGetters, mapState, mapActions} from "vuex";
import moment from "moment";
import Materiais from './Materiais.vue'
import ModalLancarPedido from "@/views/pedidos/ModalLancarPedido.vue";
import ModalMateriaisDropdown from "@/views/pedidos/ModalMateriaisDropdown.vue";
import i18n from "../../libs/i18n";
import * as dentesUS from '@/views/pedidos/odontograma/dentesUS';
import * as dentesDefault from '@/views/pedidos/odontograma/dentesDefault';
import * as dentesCriancaUS from '@/views/pedidos/odontograma/dentesCriancaUS';
import * as dentesCriancaDefault from '@/views/pedidos/odontograma/dentesCriancaDefault';

const dadosFormulario = {
  enviar: false,
  cro: '',
  assinatura: '',
  conveniado_id: '',
  paciente: '',
  cor_dente: '',
  user_id: '',
  entrega: false,
  retirada: false,
  materiais: [],
  observacoes: [],
  servicos: [
    {
      id: '',
      nome: '',
      categoria_id: '',
      servico_id: '',
      tipo_cobranca: null,
      valor: 0,
      data_prazo: '',
      data_prazo_lab: '',
      valorOriginal: 0,
      quantidade: 1,
      tipo_desconto: 0,
      desconto: 0,
      subTotal: 0,
      iva: 0,
      valor_iva: 0,
      num_dente: [],
      dente: '',
      cor_dente: '',
      observacao_item: '',
      odontograma: 'odontograma',
      mostrarOdontograma: true,
      formulario_config: [],
      formulario_dados: {},
      produtos: []
    },
  ],
  produtos: [],
}

export default {
  
  components: {
    ModalMateriaisDropdown,
    BBadge,
    BImg,
    BModal,
    ModalLancarPedido,
    max,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BCardText,
    BForm,
    BFormGroup,
    BFormCheckboxGroup,
    BFormSelect,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormTextarea,
    BFormCheckbox,
    BPopover,
    vSelect,
    Logo,
    BFormSpinbutton,
    BFormFile,
    BProgress,
    BAlert,
    BFormRadio,
    BFormRadioGroup,
    BCollapse,
    BCardHeader,
    ValidationObserver,
    ValidationProvider,
    Odontograma,
    OdontogramaCrianca,
    Materiais,
    ModalTermosServico,
    Assinatura
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
    
  },
  mixins: [heightTransition],
  data() {
    return {
      podeLimparSelectConveniados: true,
      pedidoOs: '',
      permitirConcordar: false,
      ...dataOpcoes,
      mostraDetalhesPedido: false,
      getErrors: {
        hasMessage: false,
        color: "danger",
        message: "",
        messageArray: "",
      },
      submit: false,
      form: {
        enviar: false,
        assinatura: '',
        cro: '',
        conveniado_id: '',
        paciente: '',
        cor_dente: '',
        user_id: '',
        entrega: false,
        retirada: false,
        materiais: [],
        observacoes: [],
        valor_transporte: 0,
        num_os: 0,
        os_ficha_id: 0,
        servicos: [
          {
            id: '',
            nome: '',
            categoria_id: '',
            servico_id: '',
            tipo_cobranca: null,
            valor: 0,
            data_prazo: '',
            data_prazo_lab: '',
            valorOriginal: 0,
            quantidade: 1,
            tipo_desconto: 0,
            desconto: 0,
            subTotal: 0,
            subTotalProdutos: 0,
            num_dente: [],
            dente: '',
            iva: 0,
            valor_iva: 0,
            cor_dente: '',
            observacao_item: '',
            odontograma: 'odontograma',
            mostrarOdontograma: true,
            formulario_config: [],
            formulario_dados: {},
            produtos: []
          },
        ],
        produtos: [],
      },
      respostaArquivosEnviados: [],
      respostaArquivosNaoEnviados: [],
      produtos: [],
      usuarios: [],
      porcentagem: 0,
      files: [],
      filePreviewUrls: [],
      qtdFiles: 0,
      pedidoId: 0,
      public_token: null,
      uploadProgress: [],
      isDragging: false,
      statusUpload: null,
      previewImagem: {},
      modalImagemUrl: null
    }
  },
  mounted() {
    this.initTrHeight()
    
    if (this.$route.params.id > 0) {
      this.buscaDadosServico(this.$route.params.id)
    }
  },
  created() {
    //   window.addEventListener('resize', this.initTrHeight)
    
    this.obterListaUsuarios()
    if (this.selecionado) {
      this.form.conveniado_id = ''
      this.$store.dispatch('pedidos/listaConveniados', this.selecionado)
      this.$store.dispatch('tabelas/listaTabelas', this.selecionado)
    }
  },
  computed: {
    ...mapState({
      pedidos: state => state.pedidos.pedidos,
      conveniados: state => state.pedidos.conveniados,
      laboratorios: state => state.laboratorios.laboSelecionado,
      tabela: state => state.tabelas.tabelas,
      cliente: state => state.tabelas.clienteConfig,
      materiais: state => state.materiais.materiais,
      user: state => state.user.user,
    }),
    ...mapGetters('laboratorios', ['selecionado', 'nomeLaboSelecionado', 'getPais', 'getHorarioFuncionamento', 'getFeriados']),
    ...mapGetters('pedidos', ['termoAtual']),
    
    filteredConveniados() {
      
      this.podeLimparSelectConveniados = true
      
      if (this.user.conveniado_id > 0) {
        
        this.form.conveniado_id = this.user.conveniado_id
        this.podeLimparSelectConveniados = false
        return this.conveniados.filter(conveniado => conveniado.id === this.user.conveniado_id);
        
      }
      
      return this.conveniados;
    },
    categorias() {
      if (this.tabela) {
        
        let servicos = []
        let produtos = []
        
        
        this.tabela.forEach((v) => {
          
          let categoriaNome = v.nome
          if (v.servicos.length && v.ocultar === 0) {
            
            v.servicos.forEach((serv, index) => {
              if (index === 0) {
                servicos.push({
                  nome: v.nome,
                  posicao: 0
                })
              }
              if (serv.ocultar === 0) {
                servicos.push({
                  ...serv,
                  posicao: 1,
                  nome: serv.servico_nome
                })
              }
            })
          }
          
          if (v.cat_produtos.length) {
            v.cat_produtos.forEach((prod) => {
              produtos.push({
                ...prod,
                nome: prod?.produto?.nome,
              })
            })
          }
        })
        
        return {
          servicos,
          produtos
        }
      }
    },
    
    valorTotalPedido() {
      let desconto = this.cliente.configuracoes?.desconto
      let valorBruto = this.somaValorBruto()
      let totalDesconto = desconto !== undefined || desconto > 0 ? (valorBruto / 100) * desconto : 0
      let valorLiquido = this.somaValorLiquido()
      let totalIva = this.somaTotalIva()
      
      return {
        valorBruto,
        totalDesconto,
        valorLiquido,
        totalIva
      }
    },
    
    valorTotalProdutos() {
      let valorBruto = 0;
      let valorIva = 0;
      
      this.form.servicos.forEach((v) => {
        
        if (v.produtos.length) {
          
          v.produtos.forEach( val => {
            valorBruto += parseFloat(val.valorOriginal) * val.quantidade
            valorIva += val.subTotal - (parseFloat(val.valorOriginal) * val.quantidade)
          })
        }
  
      })
      
      return {
        valorBruto: valorBruto,
        valorLiquido: valorBruto + valorIva,
        valorIva: Math.round(valorIva * 100) / 100
      }
    },
    valorEntrega() {
      if (!this.form.entrega) return 0; // Retorna 0 se não estiver marcado para entrega
      
      // Verifica se o cliente tem endereços e se o primeiro endereço tem a propriedade valor_entrega
      if (this.cliente && this.cliente.enderecos && this.cliente.enderecos.length > 0 && this.cliente.enderecos[0].valor_entrega) {
        return parseFloat(this.cliente.enderecos[0].valor_entrega); // Retorna o valor de valor_entrega
      }
      
      return 0; // Retorna 0 se nenhuma condição for atendida
    },
    totalArquivosSize() {
      if (!this.files || !this.files.length) return '0 B'
      const totalBytes = this.files.reduce((acc, f) => acc + (f.size || 0), 0)
      return this.formatFileSize(totalBytes)
    },
    
    isEnglish() {
      this.permitirConcordar = this.getPais !== "US";
      return this.getPais === "US"
    },

    requerAssinatura() {
      if (!this.termoLaboratorio) return false;
      return this.termoLaboratorio.requer_assinatura || false;
    },
    
    precisaAssinatura() {

    return this.requerAssinatura && !this.form.assinatura;

    },
    deveMostrarTermos() {
      
      return this.termoLaboratorio && this.termoLaboratorio.id;

    },
    termoLaboratorio() {
        return this.termoAtual.termo || null;
    },
  },
  watch: {
    laboratorios: {
      handler(newValue) {
        if (newValue && newValue !== 0) {
          this.carregarTermoLaboratorio();

          this.form.conveniado_id = ''
          this.$store.dispatch('pedidos/listaConveniados', this.selecionado)
          this.$store.dispatch('tabelas/listaTabelas', this.selecionado)
        }
      },
      immediate: true
    },

    valorEntrega(newValor) {
      if (!isNaN(newValor)) {
        this.form.valor_transporte = newValor;
      } else {
        this.form.valor_transporte = 0;
      }
    },

    files(newValue) {
      this.statusUpload = null
      if (newValue && newValue.length > 30) {
        this.statusUpload = false
      }
    },

    '$i18n.locale'(newLocale){
      this.permitirConcordar = newLocale !== 'en' ? true : false
    },
  },
  methods: {

    ...mapActions('pedidos', ['verificarAssinatura']),

    i18n() {
      return i18n
    },
    
    setSignature(signatureBase64) {
      this.form.assinatura = signatureBase64;
    },
    
    resetFiles() {
      this.limparArquivos()
      this.pedidoId = 0
    },
    limparArquivos() {
      this.files.forEach((_, i) => {
        if (this.filePreviewUrls[i]) URL.revokeObjectURL(this.filePreviewUrls[i])
      })
      this.files = []
      this.filePreviewUrls = []
      this.qtdFiles = 0
      this.isDragging = false
      if (this.$refs.hiddenFileInput) {
        this.$refs.hiddenFileInput.value = ''
      }
      if (this.$refs.fileInput) {
        this.$refs.fileInput.reset()
      }
    },
    removerArquivo(index) {
      if (this.filePreviewUrls[index]) URL.revokeObjectURL(this.filePreviewUrls[index])
      this.files.splice(index, 1)
      this.filePreviewUrls.splice(index, 1)
      this.qtdFiles = this.files.length
      if (this.$refs.hiddenFileInput) {
        this.$refs.hiddenFileInput.value = ''
      }
      if (this.$refs.fileInput) {
        this.$refs.fileInput.reset()
      }
    },
    triggerFileInput() {
      if (this.$refs.hiddenFileInput) {
        this.$refs.hiddenFileInput.click()
      }
    },
    onDragOver(e) {
      e.preventDefault()
      this.isDragging = true
    },
    onDragLeave(e) {
      e.preventDefault()
      this.isDragging = false
    },
    onDropFiles(e) {
      e.preventDefault()
      this.isDragging = false
      const dt = e.dataTransfer
      if (dt && dt.files && dt.files.length) {
        this.adicionarArquivos(dt.files)
      }
    },
    adicionarArquivos(fileList) {
      if (!fileList || !fileList.length) return
      for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i]
        this.files.push(file)
        this.$set(this.uploadProgress, file.name, 0)
        this.filePreviewUrls.push(
          file.type && file.type.startsWith('image/')
            ? URL.createObjectURL(file)
            : null
        )
      }
      this.qtdFiles = this.files.length
      if (this.$refs.hiddenFileInput) {
        this.$refs.hiddenFileInput.value = ''
      }
    },
    filesUpload(e) {
      const selectedFiles = e.target.files
      if (selectedFiles && selectedFiles.length) {
        this.adicionarArquivos(selectedFiles)
      }
    },
    getFileExtension(file) {
      if (!file || !file.name) return ''
      return file.name.split('.').pop().toUpperCase()
    },
    getFileBadgeVariant(file) {
      const ext = this.getFileExtension(file).toLowerCase()
      if (['stl', 'ply', 'obj'].includes(ext)) return 'light-primary'
      if (['dcm', 'dicom'].includes(ext)) return 'light-info'
      if (['pdf'].includes(ext)) return 'light-danger'
      if (['zip', 'rar', '7z', 'tar', 'gz'].includes(ext)) return 'light-warning'
      if (['mp4', 'mov', 'avi', 'mkv', 'webm', 'flv'].includes(ext)) return 'light-secondary'
      if (file.type && file.type.startsWith('image/')) return 'light-success'
      return 'light-dark'
    },
    getFileTypeCategory(file) {
      const ext = this.getFileExtension(file).toLowerCase()
      if (['stl', 'ply', 'obj'].includes(ext)) return 'primary'
      if (['dcm', 'dicom'].includes(ext)) return 'info'
      if (['pdf'].includes(ext)) return 'danger'
      if (['zip', 'rar', '7z', 'tar', 'gz'].includes(ext)) return 'warning'
      if (['mp4', 'mov', 'avi', 'mkv', 'webm', 'flv'].includes(ext)) return 'secondary'
      if (file.type && file.type.startsWith('image/')) return 'success'
      return 'secondary'
    },
    getFileIcon(file) {
      const ext = this.getFileExtension(file).toLowerCase()
      if (['pdf'].includes(ext)) return 'FileTextIcon'
      if (['mp4', 'mov', 'avi', 'flv', 'mkv', 'webm'].includes(ext)) return 'FilmIcon'
      if (['zip', 'rar', '7z', 'tar', 'gz'].includes(ext)) return 'ArchiveIcon'
      if (['stl', 'ply', 'obj'].includes(ext)) return 'BoxIcon'
      if (['dcm', 'dicom'].includes(ext)) return 'ActivityIcon'
      if (file.type && file.type.startsWith('image/')) return 'ImageIcon'
      return 'FileIcon'
    },
    formatFileSize(bytes) {
      if (bytes < 1024) return bytes + ' B'
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB'
      return (bytes / (1024 * 1024)).toFixed(1) + ' MB'
    },
    buscaDadosServico(os_ficha_id) {
      this.$http(`odontodocs/pedidos/consultar/${this.laboratorios}/${os_ficha_id}`).then((res) => {
        this.setaParametrosFicha(res.data)
      }).catch(error => {
        this.getErrors = this.$responseMessages.getMessage(error, null)
      })
    },
    setaParametrosFicha(dados) {
      this.form.paciente = dados.paciente
      this.form.conveniado_id = dados.conveniado_id
    },
    async abreModal() {
      await this.$bvModal.show('modalLancarPedido')
      await this.$refs.modalLancarPedido.handleFilesUpload()
    },
    gravaPedido() {
      this.$refs.formPedidos.validate().then(success => {
        if (success && this.statusUpload !== false) {
          
          this.submit = true
          
          if (this.$route.params.id > 0) {
            this.form.os_ficha_id = this.$route.params.id
          }
          
          this.form.user_id = this.form.user_id ? this.form.user_id.toString() : ''
          this.form.termo_aceito = this.permitirConcordar;
          this.form.termo_id = this.termoLaboratorio?.id || null;
          this.form.termo_versao = this.termoLaboratorio?.versao || null;
          
          const payload = {
            form: this.montaFormParaEnvio()
          }
          
          this.$http.post('odontodocs/pedidos/' + this.laboratorios, payload).then((res) => {
            
            this.pedidoId = res.data.pedido_id
            this.public_token = res.data.public_token
            
            if(this.form.assinatura && this.$refs.assinatura) {
              this.$refs.assinatura.clearSignature()
            }
            
            this.abreModal()
            this.$refs.materiaisDropdown.limpaMateriaisSubmit()
            
          }).catch(error => {
           /* const responseData = error.response ? error.response.data : null;

            if (error.response && error.response.status === 422) {

              const chaveMensagem = responseData?.message;

              const mensagemFinal = (chaveMensagem) 
                                    ? this.$t(chaveMensagem) 
                                    : this.$t('Houve_uma_atualizacao_nos_termos_A_pagina_sera_recarregada');

              this.$bvModal.msgBoxOk(mensagemFinal, {
                title: this.$t('Atencao'),
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: this.$t('Entendi'),
              })
              .then(() => window.location.reload())
              .catch(() => window.location.reload());

              return; 
            }
          
            console.log('grava pedido erro', error)  */
            this.getErrors = this.$responseMessages.getMessage(error, null)
            
          }).finally(() => {
            this.submit = false
            
          })
          
        }
      })
      
    },
    
    uploadCompleted() {
      
      const payload = {
        servico: this.form.servicos[0].nome ?? '',
        paciente: this.form.paciente,
        id: this.pedidoId,
        cliente: this.nomeLaboSelecionado,
        retirada: this.form.retirada
      }
      
      this.$http.post('odontodocs/pedidos/enviar/' + this.laboratorios, payload).then((res) => {
        if (res.status === 200) {
          this.limparCampos()
          this.$refs.formPedidos.reset()
        }
      }).catch(error => {
        console.log('envia pedidos erro', error)
      })
      
    },
    
    deveMostrarCampo(servico, field) {
      if (!field.show_if || !field.show_if.field) return true
      
      const parentValue = servico.formulario_dados[field.show_if.field]
      if (Array.isArray(parentValue)) {
        return parentValue.includes(field.show_if.value)
      }
      return parentValue === field.show_if.value
    },

    campoFoiRespondido(valor) {
      if (Array.isArray(valor)) return valor.length > 0
      return valor !== undefined && valor !== null && valor !== ''
    },

    limparFormularioDadosNaoRespondidos(servico) {
      if (!servico.formulario_config || !servico.formulario_config.length) {
        return servico.formulario_dados
      }

      const dadosLimpos = { ...servico.formulario_dados }

      servico.formulario_config.forEach(campo => {
        const valor = dadosLimpos[campo.name]
        if (!campo.required && !this.campoFoiRespondido(valor)) {
          delete dadosLimpos[campo.name]
        }
      })

      return dadosLimpos
    },

    montaFormParaEnvio() {
      return {
        ...this.form,
        servicos: this.form.servicos.map(servico => ({
          ...servico,
          formulario_dados: this.limparFormularioDadosNaoRespondidos(servico)
        }))
      }
    },

    renderOptions(options) {
      if (!options) return []
      return options.map(opt => ({
        text: opt.adicional > 0 ? `${opt.label} (+ ${this.$options.filters.formataMoeda(opt.adicional)})` : opt.label,
        value: opt.value || opt.label
      }))
    },

    limitSelections(value, field, index) {
      if (field.max_length && value.length > field.max_length) {
        this.$nextTick(() => {
          this.$set(this.form.servicos[index].formulario_dados, field.name, value.slice(0, field.max_length))
        })
      }
    },

    alterouCheckbox(val, index, campo) {
      const novoValor = Array.isArray(val) ? [...val] : []
      this.$set(this.form.servicos[index].formulario_dados, campo.name, novoValor)
      this.limitSelections(novoValor, campo, index)
      this.alterouQuantidade(index, this.form.servicos[index].quantidade)
      this.atualizarPreviewImagem(index, campo)
    },

    temImagemOpcoes(campo) {
      return !!(campo.options && campo.options.some(opt => opt.imagem && opt.imagem.url))
    },

    getImagemUrl(imagem) {
      return imagem && imagem.url ? `${this.$bucket_s3}/formulario_opcoes/${imagem.url}` : ''
    },

    atualizarPreviewImagem(index, campo) {
      const chave = `${index}-${campo.name}`

      if (!campo.options) {
        this.$set(this.previewImagem, chave, [])
        return
      }

      const valorSelecionado = this.form.servicos[index].formulario_dados[campo.name]
      const valores = Array.isArray(valorSelecionado) ? valorSelecionado : [valorSelecionado]

      const imagens = valores
        .map(val => campo.options.find(opt => (opt.value || opt.label) === val))
        .filter(opcao => opcao && opcao.imagem && opcao.imagem.url)
        .map(opcao => this.getImagemUrl(opcao.imagem))

      this.$set(this.previewImagem, chave, imagens)
    },

    abrirImagemMobile(url) {
      this.modalImagemUrl = url
      this.$bvModal.show('modalImagemOpcao')
    },

    limparPreviewImagem(index) {
      Object.keys(this.previewImagem).forEach(chave => {
        if (chave.startsWith(`${index}-`)) {
          this.$delete(this.previewImagem, chave)
        }
      })
    },
    
    // SERVIÇO
    mudouServico(index, val) {
      
      if (val == null) {
        this.form.servicos.splice(index, 1, this.arrayServicos())
        this.$nextTick(() => {
          if (this.$refs.odontogramaComponente && this.$refs.odontogramaComponente[index]) {
            this.$refs.odontogramaComponente[index].desativaTodos()
          }
        })
      } else {
        
        let desconto = this.cliente?.configuracoes?.desconto ?? 0
        this.form.servicos[index].id = val.id
        this.form.servicos[index].nome = val.nome
        this.form.servicos[index].categoria_id = val.categoria_id
        this.form.servicos[index].servico_id = val.id
        this.form.servicos[index].tipo_cobranca = val.tipo_cobranca ?? null
        this.form.servicos[index].valor = val.valor
        this.form.servicos[index].valorOriginal = val.valor
        this.form.servicos[index].desconto = desconto
        this.form.servicos[index].iva = val.iva
        this.form.servicos[index].formulario_config = val.formulario_config || []
        this.$set(this.form.servicos[index], 'formulario_dados', {})
        this.limparPreviewImagem(index)
        if (val.formulario_config) {
          val.formulario_config.forEach(campo => {
            this.$set(this.form.servicos[index].formulario_dados, campo.name, campo.tipo === 'checkbox' ? [] : '')
            if (this.temImagemOpcoes(campo)) {
              this.$set(this.previewImagem, `${index}-${campo.name}`, [])
            }
          })
        }
        this.alterouQuantidade(index, 1)
        this.configuraDataPrazo(index, val.dias_prazo)

        if (val.tipo_cobranca === 'arcada_completa') {
          this.form.servicos[index].num_dente = ['SUP', 'INF']
          this.form.servicos[index].dente = 'SUP,INF'
          this.form.servicos[index].quantidade = 1
          this.$nextTick(() => {
            if (this.$refs.odontogramaComponente && this.$refs.odontogramaComponente[index]) {
              this.$refs.odontogramaComponente[index].selecionarAmbasArcadas()
            }
          })
        } else if (val.tipo_cobranca === 'dente' || val.tipo_cobranca === 'arcada') {
          if (this.form.servicos[index].num_dente && this.form.servicos[index].num_dente.length > 0) {
            this.form.servicos[index].quantidade = this.calcularQuantidadeDentes(this.form.servicos[index].num_dente, this.form.servicos[index])
          } else {
            this.form.servicos[index].quantidade = 1
          }
        } else {
          if (!this.form.servicos[index].quantidade) {
            this.form.servicos[index].quantidade = 1
          }
        }

        this.alterouQuantidade(index, this.form.servicos[index].quantidade)
      }
      
    },
    arrayServicos() {
      return {
        id: 0,
        nome: '',
        categoria_id: '',
        tipo_cobranca: null,
        valor: 0,
        data_prazo: '',
        data_prazo_lab: '',
        valorOriginal: 0,
        quantidade: 1,
        tipo_desconto: 0,
        desconto: 0,
        subTotal: 0,
        num_dente: [],
        dente: '',
        cor_dente: '',
        observacao_item: '',
        odontograma: 'odontograma',
        mostrarOdontograma: true,
        formulario_config: [],
        formulario_dados: {},
      }
    },
    arrayProdutos() {
      return {
        id: '',
        nome: '',
        quantidade: 1,
        valor: 0,
        valorOriginal: 0,
        subTotal: 0,
        iva: 0,
        valor_iva: 0,
        categoria_id: ''
      }
    },
    somaValorLiquido() {
      return this.form.servicos.reduce((soma, val) => {
        return (soma + parseFloat(val.subTotal))
      }, 0)
    },
    somaValorBruto() {
      return this.form.servicos.reduce((soma, val) => {
        return (soma + parseFloat(val.valorOriginal) * val.quantidade)
      }, 0)
    },
    somaTotalIva() {
      return this.form.servicos.reduce((soma, val) => {
        return soma + val.valor_iva
      }, 0)
      
    },
    calculaSubtotal(quantidade, valor, iva) {
      let subtotal = valor * quantidade
      let desconto = this.cliente.configuracoes.desconto
      
      if (desconto > 0) {
        let desc = (subtotal / 100) * desconto
        subtotal = subtotal - desc
      }
      
      if(Number(iva) > 0) {
        subtotal = subtotal + (subtotal / 100) * iva
      }
      
      return subtotal
    },
    calculaIva(quantidade, valorServico, taxaIva ) {
      let Totservico = quantidade * valorServico
      return Math.round((Totservico / 100) * taxaIva * 100) / 100;
    },
    calculaSubtotalProdutos(produtos) {
      
      return produtos.reduce((soma, prod) => {
        return soma + parseFloat(prod.subTotal);
      }, 0);
      
    },
    
    getTipoCobrancaInfo(tipo) {
      switch (tipo) {
        case 'dente':
          return {
            label: this.$t('Cobranca_Por_Dente'),
            variant: 'light-primary',
            icon: 'GridIcon'
          }
        case 'arcada':
          return {
            label: this.$t('Cobranca_Por_Arcada'),
            variant: 'light-info',
            icon: 'LayersIcon'
          }
        case 'arcada_completa':
          return {
            label: this.$t('Cobranca_Arcada_Completa'),
            variant: 'light-warning',
            icon: 'Maximize2Icon'
          }
        default:
          return {
            label: this.$t('Cobranca_Manual'),
            variant: 'light-secondary',
            icon: 'Edit3Icon'
          }
      }
    },
    isQuantidadeDisabled(servico) {
      if (!servico || !servico.id) {
        return true
      }
      return !!(servico.tipo_cobranca && !['manual', 'livre'].includes(servico.tipo_cobranca))
    },
    onDenteSelecionado(index, dentes) {
      const servico = this.form.servicos[index]
      if (!servico) return

      servico.num_dente = dentes
      servico.dente = dentes ? dentes.toString() : ''

      if (servico.tipo_cobranca === 'dente' || servico.tipo_cobranca === 'arcada' || servico.tipo_cobranca === 'arcada_completa') {
        servico.quantidade = this.calcularQuantidadeDentes(dentes, servico)
      }

      this.alterouQuantidade(index, servico.quantidade)
    },
    calcularQuantidadeDentes(dentes, servico) {
      if (!Array.isArray(dentes) || dentes.length === 0) {
        return 1
      }

      const tipoCobranca = servico?.tipo_cobranca

      if (tipoCobranca === 'arcada_completa') {
        return 1
      }

      const isCrianca = servico?.odontograma === 'odontograma-crianca'
      const isUS = this.getPais === 'US'

      if (tipoCobranca === 'dente') {
        const countSup = isCrianca ? (isUS ? 12 : 10) : 16
        const countInf = isCrianca ? (isUS ? 12 : 10) : 16
        const individuais = dentes.filter(d => d !== 'SUP' && d !== 'INF').length
        const totalDentes = individuais + (dentes.includes('SUP') ? countSup : 0) + (dentes.includes('INF') ? countInf : 0)
        return totalDentes > 0 ? totalDentes : 1
      }

      if (tipoCobranca === 'arcada') {
        let supList = []
        let infList = []

        if (isCrianca) {
          if (isUS) {
            supList = dentesCriancaUS.arraySuperiores
            infList = dentesCriancaUS.arrayInferiores
          } else {
            supList = dentesCriancaDefault.arraySuperiores
            infList = dentesCriancaDefault.arrayInferiores
          }
        } else {
          if (isUS) {
            supList = dentesUS.arraySuperiores
            infList = dentesUS.arrayInferiores
          } else {
            supList = dentesDefault.arraySuperiores
            infList = dentesDefault.arrayInferiores
          }
        }

        const hasSup = dentes.includes('SUP') || dentes.some(d => supList.map(String).includes(String(d)))
        const hasInf = dentes.includes('INF') || dentes.some(d => infList.map(String).includes(String(d)))

        if (hasSup && hasInf) {
          return 2
        }
        if (hasSup || hasInf) {
          return 1
        }
        return 1
      }

      return servico?.quantidade ? servico.quantidade : 1
    },
    alterouQuantidade(index, quantidade) {
      const servico = this.form.servicos[index]
      let adicionalTotal = 0

      if (servico.formulario_config && servico.formulario_dados) {
        servico.formulario_config.forEach(campo => {
          if (!this.deveMostrarCampo(servico, campo)) return

          const valorSelecionado = servico.formulario_dados[campo.name]
          if (!valorSelecionado) return

          if (['radio', 'select'].includes(campo.tipo) && campo.options) {
            const opcao = campo.options.find(opt => opt.value === valorSelecionado || opt.label === valorSelecionado)
            if (opcao && opcao.adicional) {
              adicionalTotal += parseFloat(opcao.adicional)
            }
          } else if (campo.tipo === 'checkbox' && Array.isArray(valorSelecionado)) {
            valorSelecionado.forEach(val => {
              const opcao = campo.options.find(opt => opt.value === val || opt.label === val)
              if (opcao && opcao.adicional) {
                adicionalTotal += parseFloat(opcao.adicional)
              }
            })
          }
        })
      }

      let valor = parseFloat(servico.valorOriginal || 0) + adicionalTotal
      this.form.servicos[index].valor = valor
      this.form.servicos[index].valor_iva = this.calculaIva(quantidade, valor, this.form.servicos[index].iva)
      this.form.servicos[index].subTotal = this.calculaSubtotal(quantidade, valor, this.form.servicos[index].iva)
      this.form.servicos[index].subTotalProdutos = this.calculaSubtotalProdutos(this.form.servicos[index].produtos)
    },
    addNewItemInItemForm() {
      
      let index = this.form.servicos.length - 1
      
      this.form.servicos.push({
        id: '',
        nome: '',
        categoria_id: '',
        tipo_cobranca: null,
        valor: 0,
        data_prazo: '',
        data_prazo_lab: '',
        valorOriginal: 0,
        quantidade: 1,
        tipo_desconto: 0,
        desconto: 0,
        subTotal: 0,
        subTotalProdutos: 0,
        num_dente: [],
        dente: '',
        cor_dente: '',
        observacao_item: '',
        odontograma: 'odontograma',
        mostrarOdontograma: true,
        formulario_config: [],
        formulario_dados: {},
        produtos: []
      })
      
      this.$root.$emit('bv::toggle::collapse', 'collapse-' + index)
      
      
      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
        this.$refs.odontogramaComponente[index + 1].desativaTodos()
      })
    },
    removeItem(index) {
      this.form.servicos.splice(index, 1)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    
    // PRODUTO
    mudouProduto(index, indexProd, val) {
      
      if (val == null) {
        this.form.servicos[index].produtos.splice(indexProd, 1, this.arrayProdutos())
      } else {
        
        let valor_iva =  this.calculaIva(1, val.valor, val.iva)
        this.form.servicos[index].produtos[indexProd].id = val.produto_id
        this.form.servicos[index].produtos[indexProd].categoria_id = val.categoria_id
        this.form.servicos[index].produtos[indexProd].nome = val.nome
        this.form.servicos[index].produtos[indexProd].valor = val.valor ?? 0
        this.form.servicos[index].produtos[indexProd].quantidade = 1
        this.form.servicos[index].produtos[indexProd].iva = val.iva
        this.form.servicos[index].produtos[indexProd].valor_iva = valor_iva
        this.form.servicos[index].produtos[indexProd].valorOriginal = val.valor ?? 0
        this.form.servicos[index].produtos[indexProd].subTotal = (Number(val.valor) + valor_iva) ?? 0
        
        this.form.servicos[index].subTotalProdutos = this.calculaSubtotalProdutos(this.form.servicos[index].produtos)
        
      }
      
    },
    alterouQuantidadeProduto(index, indexProd, quantidade) {
      let valor = this.form.servicos[index].produtos[indexProd].valorOriginal
      this.form.servicos[index].produtos[indexProd].valor = valor
      this.form.servicos[index].produtos[indexProd].valor_iva = this.calculaIva(quantidade, valor, this.form.servicos[index].produtos[indexProd].iva)
      this.form.servicos[index].produtos[indexProd].subTotal = (valor * quantidade) + this.form.servicos[index].produtos[indexProd].valor_iva
      
      this.form.servicos[index].subTotalProdutos = this.calculaSubtotalProdutos(this.form.servicos[index].produtos)
      
      
    },
    excluirProduto(index, indexProd) {
      this.form.servicos[index].produtos.splice(indexProd, 1)
      this.form.servicos[index].subTotalProdutos = this.calculaSubtotalProdutos(this.form.servicos[index].produtos)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    addNewProductInItemForm(index) {
      this.form.servicos[index].produtos.push(
        {
          id: '',
          nome: '',
          quantidade: 1,
          valor: 0,
          valorOriginal: 0,
          subTotal: 0,
          categoria_id: ''
        }
      )
    },
    
    // OUTROS
    configuraDataPrazo(index, dias) {
      if (dias > 0) {
        
        const raw = this.getHorarioFuncionamento;
        const horarioFuncionamento = typeof raw === 'string' ? JSON.parse(raw) : raw;
        
        const existeHorariosAtivos = this.verificaHorariosAtivos(horarioFuncionamento);
        
        this.form.servicos[index].data_prazo_lab = this.calculaDataPrazo(dias - 1, horarioFuncionamento, existeHorariosAtivos);
        
        
       // const diffDias = this.$getDate.calculaQuantidadeDeDias(this.form.servicos[index].data_prazo_lab)
       // this.form.servicos[index].data_prazo = this.calculaDataPrazo(diffDias + 1, horarioFuncionamento, existeHorariosAtivos);
        
        let dataPrazoAddDay = this.$getDate.addDias(this.form.servicos[index].data_prazo_lab, 1)
        this.form.servicos[index].data_prazo  = this.calculaDataPrazo(1, horarioFuncionamento, existeHorariosAtivos, dataPrazoAddDay);
        
      }
      
    },
    verificaHorariosAtivos(horarios) {
      if (!horarios) return false;
      const lista = typeof horarios === 'string' ? JSON.parse(horarios) : horarios;
      return Array.isArray(lista) ? lista.some(horario => horario.active) : false;
    },
    
   
    calculaDataPrazo(dias, horarioFuncionamento, existeHorariosAtivos, dataPrazo = new Date()) {
      let diasValidos = 0;
      let dataAtual = new Date(dataPrazo);
   
      let contadorSeguranca = 0;
      const MAX_ITERACOES = 200;
      
      if (!horarioFuncionamento) {
        console.error('Parâmetros inválidos para calculaDataPrazo');
        return dataAtual;
      }
      
      const feriadosRaw = this.getFeriados;
      const feriadosObj = typeof feriadosRaw === 'string' ? JSON.parse(feriadosRaw) : (feriadosRaw || {});
      const feriadosDatas = [
        ...(Array.isArray(feriadosObj.feriadosNacionais) ? feriadosObj.feriadosNacionais.map(f => f.date) : []),
        ...(Array.isArray(feriadosObj.feriadosExtras) ? feriadosObj.feriadosExtras.map(f => f.date) : []),
      ];
      
     
      while (diasValidos < dias && contadorSeguranca < MAX_ITERACOES) {
        dataAtual = this.$getDate.addDias(dataAtual, 1);
        
        const diaDaSemana = moment(dataAtual).isoWeekday() - 1;
        
        if (existeHorariosAtivos) {
          if (horarioFuncionamento[diaDaSemana] &&
            horarioFuncionamento[diaDaSemana].active &&
            !feriadosDatas.includes(dataAtual)) {
            diasValidos++;
          }
        } else {
          diasValidos++;
        }
        
        contadorSeguranca++;
      }
      
      if (contadorSeguranca >= MAX_ITERACOES) {
        console.warn('Possível loop infinito detectado em calculaDataPrazo');
      }
      
      return dataAtual;
    },
    
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
    obterListaUsuarios() {
      this.$http.get('odontodocs/usuarios').then(res => {
        this.usuarios = res.data
      })
    },
    limparCampos() {
      this.$refs.odontogramaComponente[0].desativaTodos()
      this.form = {
        enviar: false,
        assinatura: '',
        cro: '',
        conveniado_id: '',
        paciente: '',
        cor_dente: '',
        user_id: '',
        num_os: 0,
        os_ficha_id: 0,
        entrega: false,
        retirada: false,
        materiais: [],
        observacoes: [],
        servicos: [
          {
            id: '',
            nome: '',
            categoria_id: '',
            servico_id: '',
            tipo_cobranca: null,
            valor: 0,
            data_prazo: '',
            data_prazo_lab: '',
            valorOriginal: 0,
            quantidade: 1,
            tipo_desconto: 0,
            desconto: 0,
            subTotal: 0,
            subTotalProdutos: 0,
            num_dente: [],
            iva: 0,
            valor_iva: 0,
            dente: '',
            cor_dente: '',
            observacao_item: '',
            odontograma: 'odontograma',
            mostrarOdontograma: true,
            formulario_config: [],
            formulario_dados: {},
            produtos: []
          },
        ],
        produtos: [],
      }
    },
    
    abreModalTermos() {
      this.$bvModal.show('modalTermos')
    },
    
    handleTermosAceitos(aceito) {
      this.permitirConcordar = aceito
    },

    async checarTermoAssinatura() {
      if (!this.selecionado) return;
    
      const clienteId = this.cliente?.id || this.user?.id; 

      try {
        // CHAMA A STORE (ACTION)
        await this.verificarAssinatura({
            cliente_id: clienteId,
            laboratorio_id: this.selecionado
        });

        if (this.termoAtual.precisa_assinar === 0 && this.termoAtual.termo) {
            this.permitirConcordar = true; 
        } else {
            this.permitirConcordar = false;
        }

      } catch (error) {
        console.error("Erro ao verificar termo via store", error);
      }
    },

    async carregarTermoLaboratorio() {

        if (!this.selecionado || this.selecionado === 0) {        
        return;       
        }
        
        try {       
        const response = await this.$http.get(       
        `odontodocs/termos/${this.selecionado}`       
        );
        
        if (response.status === 204) {     
        // Cenário: Nenhum termo ativo (Vazio)       
        this.$store.commit('pedidos/SET_STATUS_TERMO', {       
        precisa_assinar: false,       
        termo: null      
        });
        this.permitirConcordar = true;
        } else {
        this.$store.commit('pedidos/SET_STATUS_TERMO', {       
        precisa_assinar: false,       
        termo: response.data       
        });
        this.permitirConcordar = false;
        }
        } catch (error) {
        
        // NÃO TEM TERMO: liberar envio
        
        this.$store.commit('pedidos/SET_STATUS_TERMO', {       
        precisa_assinar: false,       
        termo: null        
        });

        this.permitirConcordar = true;
      }
    },
    
  },
  filters: {
    formataMoeda(valor) {
      if (!valor) return '0,00'
      
      return valor.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },
    convertData(data) {
      if (!data) return ''
      
      return moment(data).format('DD/MM/YYYY')
      
    }
  }
  
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.invoice-add-wrapper {
  .add-new-client-header {
    padding: $options-padding-y $options-padding-x;
    color: $success;
    
    &:hover {
      background-color: rgba($success, 0.12);
    }
  }
}
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import '~@core/scss/base/components/variables-dark';

.form-item-section {
  background-color: $product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

.repeater-form {
  // overflow: hidden;
  transition: .35s height;
}

.v-select {
  
  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;
    
    .dark-layout & {
      background-color: unset;
    }
  }
}

.dark-layout {
  .form-item-section {
    background-color: $theme-dark-body-bg;
    
    .row .border {
      background-color: $theme-dark-card-bg;
    }
    
  }
}

.custom-dropzone {
  border: 2px dashed #7367f0;
  border-radius: 12px;
  background-color: rgba(115, 103, 240, 0.04);
  cursor: pointer;
  transition: all 0.25s ease-in-out;
  padding: 1.5rem 1rem;

  &:hover,
  &.is-dragover {
    border-color: #5e50ee;
    background-color: rgba(115, 103, 240, 0.09);
    transform: translateY(-2px);

    .dropzone-icon-wrapper {
      transform: scale(1.08);
      background-color: rgba(115, 103, 240, 0.2);
    }
  }
}

.dropzone-icon-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: rgba(115, 103, 240, 0.12);
  transition: all 0.25s ease-in-out;
}

.dropzone-title {
  color: #5e5873;
  letter-spacing: 0.2px;
}

.file-card-modern {
  border-radius: 10px;
  border: 1px solid #ebe9f1;
  background: #ffffff;
  box-shadow: 0 3px 10px rgba(34, 41, 47, 0.05);
  overflow: hidden;
  transition: all 0.25s ease-in-out;
  display: flex;
  flex-direction: column;
  height: 100%;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 18px rgba(34, 41, 47, 0.12);

    .file-card-img {
      transform: scale(1.05);
    }
  }
}

.file-card-thumb {
  position: relative;
  height: 110px;
  overflow: hidden;
  background: #f8f8f8;
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.file-card-icon-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  &.bg-primary { background-color: rgba(115, 103, 240, 0.08) !important; }
  &.bg-info { background-color: rgba(0, 207, 232, 0.08) !important; }
  &.bg-danger { background-color: rgba(234, 84, 85, 0.08) !important; }
  &.bg-warning { background-color: rgba(255, 159, 67, 0.08) !important; }
  &.bg-success { background-color: rgba(40, 199, 111, 0.08) !important; }
  &.bg-secondary { background-color: rgba(130, 134, 139, 0.08) !important; }
}

.file-type-badge {
  position: absolute;
  bottom: 6px;
  left: 6px;
  font-size: 10px;
  text-transform: uppercase;
  padding: 2px 6px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.08);
}

.btn-delete-file {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 24px;
  height: 24px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  color: #ea5455;
  border: 1px solid rgba(234, 84, 85, 0.2);
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 5px rgba(0,0,0,0.12);

  &:hover {
    background: #ea5455;
    color: #ffffff;
    transform: scale(1.1);
  }
}

.file-card-details {
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
}

.file-card-name {
  font-size: 12px;
  font-weight: 600;
  color: #2c2c2c;
  margin-bottom: 2px;
}

.dark-layout {
  .custom-dropzone {
    border-color: rgba(115, 103, 240, 0.45);
    background-color: rgba(115, 103, 240, 0.06);

    &:hover,
    &.is-dragover {
      background-color: rgba(115, 103, 240, 0.12);
    }
  }

  .dropzone-title {
    color: #d0d2d6;
  }

  .file-card-modern {
    background: $theme-dark-card-bg;
    border-color: $theme-dark-border-color;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25);
  }

  .file-card-thumb {
    background: $theme-dark-body-bg;
  }

  .file-card-details {
    background: $theme-dark-card-bg;
  }

  .file-card-name {
    color: #d0d2d6;
  }

  .btn-delete-file {
    background: rgba(40, 48, 70, 0.9);
    border-color: rgba(234, 84, 85, 0.4);

    &:hover {
      background: #ea5455;
      color: #ffffff;
    }
  }
}

.opcao-thumb {
  width: 36px;
  height: 36px;
  object-fit: cover;
  cursor: pointer;
  border: 1px solid #e0e0e0;
}

.imagem-preview-container {
  position: sticky;
  top: 0;
  padding: 0.5rem;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fafafa;
  min-height: 100%;

  .dark-layout & {
    background: $theme-dark-card-bg;
    border-color: $theme-dark-border-color;
  }
}

.imagem-preview-img {
  width: 100%;
  max-height: 220px;
  object-fit: contain;
}

.imagem-preview-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  font-size: 13px;
  text-align: center;
}
</style>
